import GenerateEnum from '../generateEnum'
import { getLabelText } from '../utils'

export const invoiceAmountTypeEnum = GenerateEnum({
  POSITIVE: {
    value: 5,
    label: getLabelText({
      key: 'remote.admin.invoiceAmountTypePositive',
      text: '正数发票',
    })
  },
  NEGATIVE: {
    value: 6,
    label: getLabelText({
      key: 'remote.admin.invoiceAmountTypeNegative',
      text: '负数发票',
    })
  }
})

export const auditTypeEnum = GenerateEnum({
  MANUAL: {
    value: 0,
    label: getLabelText({
      key: 'remote.admin.manualReview',
      text: '人工审核',
    })
  },
  AUTO: {
    value: 1,
    label: getLabelText({
      key: 'remote.admin.automaticReview',
      text: '自动审核',
    })
  }
})

export const pdfParseEnum = GenerateEnum({
  STIFTUNG_ELEKTRO_ALTGERATE_REGISTER: {
    value: 0,
    label: 'Stiftung Elektro-Altgerate Register'
  },
  GR_OR_GRS: {
    value: 1,
    label: 'Gemeinsames Ruecknahm'
  },
  GRS_SERVICE_GMBH: {
    value: 2,
    label: 'GRS SERVICE GMBH'
  },
  LANDBELL: {
    value: 3,
    label: ' Landbell'
  },
  EVATMASTER_GLOBAL_SL: {
    value: 5,
    label: 'EVATMASTER GLOBAL S.L.'
  },
  ECOSYSTEM: {
    value: 7,
    label: 'ECOSYSTEM'
  }
})



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/invoice.js